export const getAuthors = () => `/api/v1/authors`;
export const findAuthor = hashedId => `/api/v1/authors/${hashedId}?include=articles,books,credentials`;